import { createReducer, on } from '@ngrx/store';
import {
  loadFeatureAvailability,
  loadFeatureAvailabilityFailure,
  loadFeatureAvailabilitySuccess,
  resetFeatureAvailability,
} from './feature-availability.actions';
import { FeatureAvailabilityState } from './feature-availability.models';

export const initialState: FeatureAvailabilityState = {
  features: [],
  loaded: false,
  loading: false,
  error: null,
};

export const featureAvailabilityReducer = createReducer(
  initialState,
  on(loadFeatureAvailability, (state) => ({ ...state, loading: true, error: null })),
  on(loadFeatureAvailabilitySuccess, (state, { features }) => ({
    ...state,
    features,
    loaded: true,
    loading: false,
    error: null,
  })),
  on(loadFeatureAvailabilityFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    loading: false,
    error,
  })),
  on(resetFeatureAvailability, () => initialState),
);
